import { render, staticRenderFns } from "./RsaSchedaPsicologicaSuapEditComponent.vue?vue&type=template&id=4a6a90bc"
import script from "./RsaSchedaPsicologicaSuapEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaPsicologicaSuapEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports